/**
 * @generated SignedSource<<4939bb1d64485c5c9196022ad7ca61e3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type Speaker = "LEARNER" | "TUTOR" | "%future added value";
export type SessionViewTurnsQuery$variables = {
  sessionId: string;
};
export type SessionViewTurnsQuery$data = {
  readonly me: {
    readonly learner: {
      readonly displayName: string;
      readonly id: string;
      readonly nativeLanguage: string | null | undefined;
      readonly picture: {
        readonly preset: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly session: {
    readonly id: string;
    readonly status: SessionStatus;
    readonly turns: {
      readonly nodes: ReadonlyArray<{
        readonly errors: ReadonlyArray<{
          readonly id: string;
          readonly learnerForm: string;
          readonly span: {
            readonly end: number;
            readonly start: number;
          } | null | undefined;
          readonly targetForm: string;
        }>;
        readonly id: string;
        readonly speaker: Speaker;
        readonly transcript: string;
        readonly translationTarget: string | null | undefined;
      }>;
    };
  } | null | undefined;
  readonly tutorReady: boolean;
};
export type SessionViewTurnsQuery = {
  response: SessionViewTurnsQuery$data;
  variables: SessionViewTurnsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tutorReady",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nativeLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerPicture",
            "kind": "LinkedField",
            "name": "picture",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "sessionId"
      }
    ],
    "concreteType": "Session",
    "kind": "LinkedField",
    "name": "session",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TurnConnection",
        "kind": "LinkedField",
        "name": "turns",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Turn",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "speaker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transcript",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translationTarget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ErrorRecord",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "learnerForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "targetForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ErrorSpan",
                    "kind": "LinkedField",
                    "name": "span",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "start",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "end",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionViewTurnsQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SessionViewTurnsQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "e176b4d12617b409a8a524e29ab0c676",
    "id": null,
    "metadata": {},
    "name": "SessionViewTurnsQuery",
    "operationKind": "query",
    "text": "query SessionViewTurnsQuery(\n  $sessionId: ID!\n) {\n  tutorReady\n  me {\n    learner {\n      id\n      nativeLanguage\n      displayName\n      picture {\n        preset\n        url\n      }\n    }\n  }\n  session(id: $sessionId) {\n    id\n    status\n    turns {\n      nodes {\n        id\n        speaker\n        transcript\n        translationTarget\n        errors {\n          id\n          learnerForm\n          targetForm\n          span {\n            start\n            end\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9cf1d69db6924b81e30ed243c20dcfe4";

export default node;
